import { createSelector } from 'reselect'
import { refElements } from 'components/Canvas/renderer/utils/elementUtils'

const getCanvasState = (state) => state.canvas
const selectElementById = (state) => getCanvasState(state).elementById
export const selectCanvasDetails = (state) => getCanvasState(state).details
export const selectElementSelector = (state) => getCanvasState(state).elementSelector
export const selectParentId = (state) => getCanvasState(state).parentId
export const selectSelectedId = (state) => getCanvasState(state).selectedId
export const selectIsStateChanged = (state) => getCanvasState(state).isStateChanged
export const selectOverElementId = (state) => getCanvasState(state).overElementId
export const selectIsElementChange = (state) => getCanvasState(state).isElementChange
const selectElementId = (_, props) => props.elementId

export const selectCanvasBluePrint = createSelector(
  [selectCanvasDetails, selectElementById],
  (details, elementById) => ({
    details,
    elementById,
  })
)

export const selectElementFromId = createSelector(
  [selectElementById, selectElementId],
  (elementById, elementId) => {
    return elementById[elementId]
  }
)

export const selectElementFromSelectedId = createSelector(
  [selectElementById, selectSelectedId],
  (elementById, selectedId) => {
    const element = elementById[selectedId]
    if(element && element.refElement === refElements.COLUMNS){
      return ({
        ...element,
        elements: element.elements.map((id) => elementById[id]),
      })
    }
    return element
  }
)



// WEBPACK FOOTER //
// ./src/store/canvas/selectors.js